import BaseComponent from 'scripts/BaseComponent.js';

export default class Header extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      accountBtn: '.js-accountBtn',
      accountDrawerOpenClass: 'js-accountDrawerOpen',
      accountDirectClass: 'js-directToAccount',
      $accountBtn: this.$get(this.refs.accountBtn),
    };

    this.dom = {
      $component: component,
      $navigation: this.$get(this.refs.navigation),
      $accountBtn: this.$getAll(this.refs.accountBtn),
    };

    this.state = {
      oldScroll: 0,
      isScrolling: null,
      openAccountDrawerEvent: 'openaccountdrawer',
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    const { dom } = this;

    this.checkPin();
    this.setOnEvent('scroll', window, this.checkScroll, false);
    this.setClickWithElement(dom.$accountBtn, this.accountBtnClick);
  }

  checkScroll() {
    const { state } = this;

    window.clearTimeout(state.isScrolling);

    state.isScrolling = setTimeout(this.setScrollingClass.bind(this), 1);
  }

  setScrollingClass() {
    const { dom, state } = this;
    const scrollTop = window.pageYOffset;

    if (state.oldScroll < scrollTop) {
      dom.$component.classList.add('is-scrolled');
    } else {
      dom.$component.classList.remove('is-scrolled');
    }

    state.oldScroll = scrollTop <= 0 ? 0 : scrollTop;
  }

  checkPin() {
    const { dom } = this;

    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle('is-pinned', e.intersectionRatio < 1),
      { threshold: [1] },
    );

    observer.observe(dom.$component);
  }

  accountBtnClick(element) {
    const { refs, state } = this;
    if (element.classList.contains(refs.accountDrawerOpenClass)) {
      this.dispatch(state.openAccountDrawerEvent);
    } else if (element.classList.contains(refs.accountDirectClass)) {
      window.location.href = '/account';
    }
  }
}
